import {
  CPPAPType,
  PrblmActivePlan,
  PrblmActivePlanICD10Code,
  PreApprovedOptionType,
  PreApprovedPlanListType,
  PreApprovedPlanType,
  PreApprovedTemplateType
} from "DataTypes/PatientManagement.type";
import {
  CheckArr,
  CheckBoolean,
  CheckNumber,
  CheckStringEmpty
} from "./common";

const TemplateSearch: (data: any) => PreApprovedTemplateType[] = (data) => {
  const checkedArr = CheckArr(data);
  return checkedArr.map(el => {
    return {
      categoryId: CheckNumber(el.categoryId),
      categoryType: CheckStringEmpty(el?.categoryType || el?.categoryName),
      options: FlatTemplateSearch(el?.options).map(optEl => PlanOptions(optEl))
    }
  })
};

const FlatTemplateSearch: (
  dataArr: any,
  parentId?: any
) => any[] = (dataArr, parentId = null) => {
  let result: any[] = [];

  for (const node of dataArr) {
    // push current node with derived parentId
    result.push({
      id: node?.id,
      label: node?.label,
      parentId: parentId || node?.parentId
    });

    // recurse into children
    if (node?.subOptionsList && node?.subOptionsList?.length > 0) {
      result = result.concat(
        FlatTemplateSearch(node?.subOptionsList, node?.id)
      );
    }
  }
  return result;
}

const PlanOptions: (data: any) => PreApprovedOptionType = (data) => {
  return {
    id: CheckNumber(data?.id),
    label: CheckStringEmpty(data?.label),
    parentId: CheckNumber(data?.parentId)
  }
};

const PlanSearch: (data: any) => PreApprovedPlanType = (data) => {
  return {
    approvalStatus: CheckStringEmpty(data?.approvalStatus),
    category: TemplateSearch(data?.category),
    planId: CheckNumber(data?.planId),
    problemId: CheckNumber(data?.problemId),
    problemName: CheckStringEmpty(data?.problemName),
    status: CheckStringEmpty(data?.status),
  }
}

const PlanList: (data: any) => PreApprovedPlanListType[] = (data) => {
  const checkedArr = CheckArr(data);
  return checkedArr.map(el => {
    const approvalStatus = CheckStringEmpty(el?.approvalStatus);
    const status = CheckStringEmpty(el?.approvalStatus);
    const createdBy = CheckStringEmpty(el?.createdByFullname);
    const createdByDesig = CheckStringEmpty(el?.createdByDesignation);
    const planId = CheckNumber(el?.id);
    const versionNumber = CheckNumber(el?.versionNumber);

    return {
      approvalStatus,
      createdat: CheckStringEmpty(el?.createdAt),
      createdby: createdBy
        ? `${createdBy}${createdByDesig ? ", " + createdByDesig : ""}`
        : "",
      description: CheckStringEmpty(el?.description),
      disabledByRoleId: CheckNumber(el?.disabledByRole),
      id: `${planId}-${versionNumber}`,
      isAdminDisabled: CheckBoolean(el?.isAdminDisabled),
      isDisabled: CheckBoolean(el?.isDisabled),
      locationName: CheckStringEmpty(el?.locationName),
      planId,
      planName: CheckStringEmpty(el?.planName),
      practiceName: CheckStringEmpty(el?.practiceName),
      problemName: CheckStringEmpty(el?.problemName),
      sharedWithProvider: CheckBoolean(el?.sharedWithProvider),
      status,
      updatedByFullname: CheckStringEmpty(el?.updatedByFullname),
      versionId: CheckNumber(el?.planVersionId),
      versionNumber,
    }
  })
};

const PrblmActivePlanList: (data: any) => PrblmActivePlan[] = (data) => {
  const CheckedArr = CheckArr(data);
  return CheckedArr.map(el => {
    return {
      id: CheckNumber(el?.problemId),
      problemId: CheckNumber(el?.problemId),
      problemName: CheckStringEmpty(el?.problemName),
      activePlanId: CheckNumber(el?.activePlanId),
      icd10CodeList: PrblmActivePlanListICD10Code(el?.icd10CdeResponseDtoList),
      isPlanInUse: CheckBoolean(el?.isPlanInUse),
      isPlanEdited: CheckBoolean(el?.isPlanEdited),
    }
  })
};

const PrblmActivePlanListICD10Code: (
  data: any
) => PrblmActivePlanICD10Code[] = (data) => {
  const CheckedArr = CheckArr(data);
  return CheckedArr.map(el => {
    return {
      id: CheckNumber(el?.id),
      idc10Code: CheckStringEmpty(el?.idc10Code),
      idc10CodeName: CheckStringEmpty(el?.idc10CodeName),
      idc10Codedescription: CheckStringEmpty(el?.idc10Codedescription)
    }
  })
};

const PAPSummary: (data: any) => CPPAPType[] = (data) => {
  const checkedArr = CheckArr(data?.problems);
  return checkedArr.map(el => {
    return {
      category: TemplateSearch(el?.categories),
      icdCodes: CheckArr(el?.icdCodes).map(el1 => {
        return {
          description: CheckStringEmpty(el1?.description),
          icdCode: CheckStringEmpty(el1?.icdCode),
        }
      }),
      problemId: CheckNumber(el?.problemId),
      problemName: CheckStringEmpty(el?.problemName)
    }
  });
};

export default {
  TemplateSearch,
  PlanSearch,
  PlanList,
  PrblmActivePlanList,
  PrblmActivePlanListICD10Code,
  PAPSummary
}